import React from 'react';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import SettingField from 'components/Fields/ReduxForm/SettingField';
import SettingFieldWithIcon from 'components/Fields/ReduxForm/SettingFieldWithIcon';
import { onClickCancel, askDeleteGratuity } from 'actions/library/gratuity';
import { connect } from 'react-redux';
import styles from './GratuityForm.css';

const validate = values => {
  const errors = {};
  if (!values.name || values.name.trim() === '') {
    errors.name = 'Please enter a value';
  } else if (values.name.length > 100) {
    errors.name = 'Name too long';
  }
  if (!values.amount || isNaN(values.amount)) {
    errors.amount = 'Please enter a value';
  } else if (values.amount < 1) {
    errors.amount = 'Please enter a value greater than or equal 1';
  } else if (values.amount > 100) {
    errors.amount = 'Please input gratuity amount less than 100%';
  }
  return errors;
};

class GratuityForm extends React.Component {
  render() {
    const { handleSubmit, outlets, isSubmittingForm } = this.props;
    return (
      <form onSubmit={this.props.handleSubmit} className={styles.wrapper}>
        <div className={`${styles['field-wrapper']} gratuity-field-wrapper`}>
          <div className={styles.title}>Gratuity Information</div>
          <div className="row">
            <div className="col-sm-12">
              <Field component="input" type="hidden" name="id" />
              <div className="col-sm-6 col-md-6" style={{ paddingLeft: 0 }}>
                <Field
                  component={SettingField}
                  name="name"
                  className="form-control"
                  placeholder="Name"
                />
              </div>
              <div className="col-sm-6 col-md-6" style={{ paddingLeft: 0 }}>
                <Field
                  component={SettingFieldWithIcon}
                  name="amount"
                  icon="%"
                  className="form-control"
                  placeholder="Amount"
                  positiveNumberOnly
                  maxFractionDigits={3}
                />
              </div>
            </div>
          </div>
        </div>
        <div className={styles.footer}>
          {this.props.gratuity.id && (
            <span className="pull-left">
              <button
                className="btn btn-danger"
                onClick={this._onClickDelete}
                type="button"
                disabled={isSubmittingForm}
              >
                <i className="fa fa-trash" />
              </button>
            </span>
          )}
          <span className="pull-right">
            <button
              className={`btn btn-default ${styles['btn-cancel']}`}
              onClick={this._onClickCancel}
              type="button"
              disabled={isSubmittingForm}
            >
              Cancel
            </button>
            {outlets && outlets.length > 1 && !this.props.gratuity.id && (
              <button
                type="button"
                name="submit"
                onClick={handleSubmit(this._onSubmitCreateAllOutlet)}
                className={`btn btn-primary ${styles['btn-save-all']}`}
                disabled={isSubmittingForm}
              >
                Save to All Outlet
              </button>
            )}
            <button
              className={`btn btn-primary ${styles['btn-save']}`}
              onClick={handleSubmit(this._onSubmitSave)}
              type="button"
              disabled={isSubmittingForm}
            >
              Save
            </button>
          </span>
        </div>
      </form>
    );
  }

  _onClickCancel = e => {
    this.props.dispatch(onClickCancel());
    e.preventDefault();
    e.stopPropagation();
  };

  _onSubmitCreateAllOutlet = values => {
    this.props.onSubmit({ ...values, action: 'save_to_all_outlet' });
  };

  _onSubmitSave = values => {
    this.props.onSubmit({ ...values, action: 'save' });
  };

  _onClickDelete = e => {
    const { dispatch, gratuityDetail } = this.props;
    dispatch(askDeleteGratuity(gratuityDetail));
    e.preventDefault();
    e.stopPropagation();
  };
}

const selector = formValueSelector('gratuity');

function mapStateToProps(state) {
  const {
    gratuities,
    gratuityDetail,
    outlets,
    isSubmittingForm,
  } = state.library.gratuity;

  return {
    gratuityDetail,
    gratuity: {
      id: selector(state, 'id'),
    },
    gratuities,
    outlets,
    isSubmittingForm,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

const mapForm = {
  form: 'gratuity',
  touchOnBlur: false,
  touchOnChange: true,
  validate,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm(mapForm)(GratuityForm));
